<template>
  <ScipherLayout v-restore-scroll="{ data: getScrollData, fnc: loadInitialData }">
    <div class="m-4 p-3">
      <div>
        <v-text-field v-model="searchText" outline height="0" :full-width="true" append-icon="mdi-magnify" label="Search text" @keydown.enter="getData" @keydown.esc="clearSearchText" />
      </div>

      <v-data-table class="elevation-1" :headers="userHeaders" :items="users" :pagination.sync="pagination" :loading="true" hide-actions>
        <v-progress-linear v-show="isLoading" slot="progress" color="blue" indeterminate />
        <template v-slot:items="{ item }">
          <tr>
            <td>
              <span>{{ item.name }}</span>
            </td>
            <td>
              <span>{{ item.userName }}</span>
            </td>
            <td>
              <a class="clickable" :href="`/Client/Edit/${item.clientId}`" v-if="item.clientId">{{ item.clientName }}</a>
              <span v-else>NO CLIENT ASSIGNED</span>
            </td>
            <td>
              <span>{{ item.lastLogin && dateFormat(item.lastLogin) }}</span>
            </td>
            <td>
              <v-icon title="Locked" v-if="item.locked">mdi-lock</v-icon>
            </td>
            <td>
              <a class="clickable" :href="`/User/Edit/${item.userId}`">Edit</a>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </ScipherLayout>
</template>

<script>
import axios from '../../axios';
import ScipherLayout from '../../components/analytics/layout/ScipherLayout.vue';
import { errorDebug } from '../../libraries/common';
export default {
  components: { ScipherLayout },
  data() {
    return {
      isLoading: false,
      users: [],
      searchText: null,
      userHeaders: [
        { text: 'Name', class: ['hvh-table-header width-100px'], sortable: true, value: 'name', },
        { text: 'User Name', class: ['hvh-table-header width-200px'], sortable: true, value: 'userName', },
        { text: 'Client Name', class: ['hvh-table-header'], sortable: true, value: 'clientName', },
        { text: 'Last Login', class: ['hvh-table-header', 'width-200px'], sortable: true, value: 'lastLogin', },
        { text: 'Locked', class: ['hvh-table-header width-100px'], sortable: true, value: 'locked', },
        { text: '', sortable: false, },
      ],
      pagination: {
        ascending: true,
        sortBy: 'userName',
        page: 1,
        rowsPerPage: 1000,
      },
    };
  },
  methods: {
    getData() {
      this.isLoading = true
      return axios.get(`/Manage/GetAllApplicationUsers`, { params: { searchText: this.searchText } })
        .then(({ data }) => this.users = data)
        .catch(errorDebug)
        .then(() => {
          this.isLoading = false;
          this.triggerScrollSave();
        });
    },
    getScrollData() {
      return {
        searchText: this.searchText,
        pagination: { ...this.pagination },
      };
    },
    loadInitialData(initialScrollData) {
      this.searchText = initialScrollData.searchText;
      this.pagination = initialScrollData.pagination;
      return this.getData()
    },
    triggerScrollSave() {
      window.scrollBy(0, 1);
      window.scrollBy(0, -1);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisAllApplicationUsers'] = this;

    if (!this.isLoading)
      this.getData();
  },
}
</script>
